(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ify-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ify-product]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-ify-variants]').textContent);
    const idInput = root.querySelector('[data-ify-variant-id]');
    const price = root.querySelector('[data-ify-price]');
    const compare = root.querySelector('[data-ify-compare]');
    const status = root.querySelector('[data-ify-status]');
    const statusLabel = root.querySelector('[data-ify-status-label]');
    const add = root.querySelector('[data-ify-add]');
    const addLabel = root.querySelector('[data-ify-add-label]');
    const sku = root.querySelector('[data-ify-sku]');
    const currency = window.Shopify?.currency?.active || 'CHF';
    const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'de-CH', { style:'currency', currency }).format(value / 100);
    const activateMedia = (id) => {
      root.querySelectorAll('[data-ify-media]').forEach((item) => { item.hidden = item.dataset.mediaId !== String(id); });
      root.querySelectorAll('[data-ify-thumb]').forEach((item) => { item.setAttribute('aria-pressed', item.dataset.mediaId === String(id) ? 'true' : 'false'); });
    };
    root.querySelectorAll('[data-ify-thumb]').forEach((button) => button.addEventListener('click', () => activateMedia(button.dataset.mediaId)));
    root.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', () => {
      const selected = [...root.querySelectorAll('[data-option-position]:checked')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((item) => item.value);
      const variant = variants.find((item) => item.options.every((option,index) => option === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = money(variant.price);
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
      status.dataset.available = variant.available ? 'true' : 'false';
      statusLabel.textContent = variant.available ? 'Auf Lager' : 'Ausverkauft';
      add.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (sku) sku.textContent = variant.sku || '—';
      if (variant.featured_media) activateMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }));
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-ify-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-ify-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold:.12 });
      root.querySelectorAll('.ify-pdp-reveal').forEach((item) => observer.observe(item));
    } else root.querySelectorAll('.ify-pdp-reveal').forEach((item) => item.classList.add('is-visible'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ify-theme-polish"] && !Shopify.designMode) return;
  try {
    
  const ifyHeader = document.querySelector('#header-component');
  if (ifyHeader && ifyHeader.dataset.ifyReady !== 'true') {
    ifyHeader.dataset.ifyReady = 'true';
    const update = () => ifyHeader.classList.toggle('ify-is-scrolled', window.scrollY > 12);
    update();
    window.addEventListener('scroll', update, { passive:true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
